export default {
    "lang": "中文(简体)",
    application: {
        name: '信息发布系统',
    },
    ajaxTip: {
        success: '成功',
        error: '失败',
        noAccess: '无权访问此资源',
        notFound: '访问资源不存在',
        serverBusy: '服务器繁忙',
        timeOut: '超时',
    },
    menu: {
        home: '首页',
        template: '模板管理',
        program: '节目管理',
        playplan: '播放计划',
        device: '设备管理',
        "source-material": '素材管理',
        material: '素材',
        checkManage: '审核管理',
        setting: '设置',
        usercenter: "用户中心",
        adminManage: "设备管理",
        schedule: "待办事项",
        capitalassets: "资产管理",
        modifyPassword: "修改密码",
        logout: "退出登录",
        add: "添加",
        edit: "编辑",
        delete: "删除",
        view: "查看",
        "menu_1": "首页",
        "menu_2": "设备管理",
        "menu_3": "编辑(高级设置-普通编辑-更换网络)",
        "menu_4": "及时指令",
        "menu_5": "编辑(转移部门)",
        "menu_6": "策略",
        "menu_7": "音量设置",
        "menu_8": "亮度设置",
        "menu_9": "下载设置",
        "menu_10": "休眠设置",
        "menu_11": "设备属性",
        "menu_12": "编辑/添加",
        "menu_13": "节目管理",
        "menu_14": "发布历史",
        "menu_15": "删除（批量/单个）",
        "menu_16": "发布中的节目",
        "menu_17": "分组",
        "menu_19": "节目列表",
        "menu_20": "内容编辑",
        "menu_21": "节目复制",
        "menu_23": "节目发布",
        "menu_24": "素材管理",
        "menu_25": "上传",
        "menu_28": "快捷发布",
        "menu_29": "模板管理",
        "menu_30": "公共模版",
        "menu_31": "立即使用",
        "menu_32": "我的模板",
        "menu_33": "发布到公共模板",
        "menu_35": "共享记录",
        "menu_36": "审核管理",
        "menu_37": "节目审核",
        "menu_38": "审核（通过/拒绝）",
        "menu_39": "素材审核",
        "menu_41": "审核历史（操作员）",
        "menu_42": "审核历史（审核员）",
        "menu_43": "审批数量查看",
        "menu_44": "组织管理",
        "menu_45": "日志管理",
        "menu_46": "播放日志",
        "menu_47": "发布日志",
        "menu_48": "错误日志",
        "menu_49": "操作日志",
        "menu_50": "文件日志",
        "menu_51": "登录日志",
        "menu_52": "内容审批",
        "menu_53": "存储空间",
        "menu_54": "组织架构",
        "menu_55": "角色权限",
        "menu_56": "授权",
        "menu_57": "查看(授权权限)",
        "menu_58": "组织成员",
        "menu_60": "重置下级用户密码",
        "menu_61": "资产管理",
        "menu_62": "我的余额",
        "menu_63": "查看(资金明细)",
        "menu_64": "我的流量",
        "menu_65": "查看(流量明细)",
        "menu_66": "购买流量",
        "menu_67": "我的容量",
        "menu_68": "我的设备",
        "menu_69": "订单明细",
        "menu_70": "查看(充值)",
        "menu_71": "查看(购买模版)",
        "menu_72": "查看(购买流量)",
        "menu_73": "其他权限",
        "menu_74": "查看(素材节目统计)",
        "menu_75": "查看(资产)",
        "menu_76": "查看(云流量/统计)",
        "menu_77": "查看(设备在线统计)"
    },
    login: {
        terminalServiceSystem: '智慧终端服务系统',
        accountLogin: '账号登录',
        register: '注册',
        accountLoginTip: '已有账号登录',
        scanQRCode: '请扫二维码',
        readAndAgree: '我已阅读并同意',
        readAndAgreeLink: '用户服务协议',
        readAndAgreeAgreement: '请阅读并同意用户服务协议',
        forgetpassword: "忘记密码？",
        resetpassword: "重置密码",
        phoneEmptyTip: "请输入手机号",
        nextStep: "下一步",
        title: '欢迎登录',
        submit: '登录',
        userName: '账号',
        password: '密码',
        userNameEmptyTip: '请输入账号',
        passwordEmptyTip: '请输入密码',
        passwordFormatTip: '请输入正确的密码格式',
        passwordIsOk: '请输入确认密码',
        passwordSign: '请输入密码',
        codeTip: "请输入验证码",
        phone: "手机号不能为空",
        code: "验证码不能为空",
        nickname: "公司名称不能为空",
        pass: "密码不能为空",
        pwdMessage: "密码长度8~20字符，不能包含空格且必须包含大小写字母、数字、特殊字符其中3种",
        pwdMessage01: "请输入密码字母加数字八位以上",
        pwdMessage02: "密码长度8-20个字符",
        pwdMessage03: "密码不能包含空格",
        pwdMessage04: "密码必须包含大写字母、小写字母、数字、符号其中三种",
        newpassempty: "新密码不能为空",
        newpass: "两次密码不一致",
        getcode: "获取验证码",
        format: "手机号格式不正确",
        chongfa: "秒后重发",
        isSend: '已发送',
        noregister: "没有账号？立即注册",
        Mobile: "手机号",
        verificationcode: "验证码",
        petname: "昵称",
        Quickregistration: "快速注册",
        xiugaimima: "修改密码",
        jiumima: "旧密码",
        xinmima: "新密码",
        zaicishuruxinmima: "再次输入新密码",
        xiugaichenggong: "修改成功",
        xiugaishoujihao: "修改手机号",
        dengluzhanghao: "登录账号",
        gongsiid: "公司id",
        yonghunicheng: "用户昵称",
        chuangjianshijian: "创建时间",
        gongsimingcheng: "公司名称",
        denglumima: "登录密码",
        jianyi: "建议使用字母数字组合的密码",
        shezhimima: "设置密码",
        shezhishoujihao: "修改/设置手机号",
        yibangding: "已绑定",
        weibangding: "未绑定",
        zhanghuanquan: "账户安全",
        yonghuxinxi: "用户信息",
        zhuceSucMsg: '恭喜您,注册成功!',
        verificationcodeSucMsg: "验证码发送成功！",
        requiredIsEmpty: "必填项不能为空！",
        emailObj: {
            title: '邮箱',
            tit: '邮箱登录',
            tip: '请输入邮箱地址',
            formatTip: '请输入正确的邮箱格式',
        },
        phoneObj: {
            title: '手机号',
            tit: '手机登录',
            tip: '请输入手机号',
            formatTip: '请输入正确的手机号格式',
        },
        emailOrPhoneObj: {
            title: '邮箱或手机号',
            tit: '邮箱或手机号登录',
            tip: '请输入邮箱或手机号',
            formatTip: '请输入正确的邮箱或手机号格式',
        },
        wechatObj: {
            title: '微信',
            tit: '微信登录',
        },
        googleObj: {
            title: '谷歌',
            tit: '谷歌登录',
        },
        confirm: '确定',
        confirmSubmit: '确定提交',
        cancel: '取消',
        close: '关闭',
        bindSucMsg: '绑定成功',
        toContinueBindAccount: '继续以完成第三方账号绑定',
        bindTip01: '没有账号？注册一个',
        bindTip02: '已有账号',
        bindTip03: '当前第三方账号未绑定平台账号，请绑定已有账号或注册绑定新账号，下次即可快速登录。',
        bindTip04: '绑定已有账号',
        bindTip05: '注册绑定新账号',
        bindTip06: '你已通过第三方授权，完善以下登录信息即可完成绑定',
        bindSubmit: '提交绑定',
        enterAccountTip: '请输入账户名称',
        RegisterAndBind: '注册并绑定',
        loginErr: '用户名或密码错误！',
        usercenter: "用户中心",
        pleaseInputName: "请输入名称",
        operationSuccess: "操作成功！",
        edit: "编辑",
        xiugai: "修改",
        userData: "个人资料",
        changePassword: "密码修改",
        account: "账号",
        userName01: "用户名",
        phoneNumber: "手机号",
        role: "角色",
        createTime: "创建时间",
        genghuang: "更换",
        bangding: "绑定",
        unbind: "解绑",
        plesaseSelectBindingType: "请选择绑定类型",
        pleaseConfirmCont: "请确认我已阅读此内容",
        confirmReadCont: "我已阅读此内容",
        frequentTip: "操作太频繁,请稍后再获取!",
        zhuxiaoBtn: "注销账号",
        zhuxiaoTitle: "账号注销",
        querenZhuxiao: "确定注销",
        jiXu: "继续",
        sendCodeBtn: "发送验证码",
        passwordIsNotOldPassword: "确认密码与新密码输入的不同",
        passwordIsOldPassword: "修改密码与原密码相同",
        passFormatError: "请输入正确的密码格式",
        oldPassWord: "原密码",
        newPassWord: "新密码",
        inputPlaceholder: '请输入',
        confirmPassword: "确认密码",
        zhuxiaoTip: `
            1、注销账号为不可恢复操作，账号一旦注销，您将无法再登录及使用本账号或通过本账号注册登录的第三方账号，请自行备份账号相关信息及数据。
            2、本账号注册前，请您务必确认已清空全部资产等且不存在任何争议；本账号一经注销、即视为您放弃对本账号内的全部资产及权益的所有权，且无法恢复或找回。
            3、同一手机号注册的账号累计注销满3次的，该手机号将无法再次注册新账号，同时亦无法绑定任何其他账号。
            `
    },
    home: {
        title: "首页",
        quickOperation: "快捷操作",
        addDevice: "添加设备",
        publishProgram: "发布节目",
        publishMaterial: "发布素材",
        makeProgram: "制作节目",
        uploadMaterial: "上传素材",
        todayData: "今日数据（每小时更新）",
        playNumChart: "播放次数统计",
        deviceOnlineStatus: "设备在线情况",
        onLineDevice: "在线设备",
        unLineDevice: "离线设备",
        programPlayTime: "节目播放时长统计",
        downloadSoft: "软件下载",
        adminApp: "手机用户端",
        playerApp: "信发播放终端",
        downloadAdminApp: "点击下载用户端",
        downloadPlayerApp: "点击下载播放端",
        aboutUs: "关于我们",
        userManual: "用户手册",
        message: "我要留言",
    },
    device: {
        inputPlaceholder: '请输入',
        selectPlaceholder: '请选择',
        osTypeStr: '终端系统',
        onLineStatus: '在线状态',
        dpi: '分辨率',
        companyDeptIdName: '所属机构',
        deviceGroupIdName: '所属分组',
        editOrMove: '编辑/移动',
        loanOriginationFee: '贷款手续费',
        strategyInfoLook: '策略信息查看',
        programLook: '节目查看',
        addEquipments: '添加设备',
        luminanceSet: '亮度控制',
        terminal: '终端设置',
        transferCompany: '转移部门',
        releasedProgram: '发布节目',
        screenshot: '截图',
        changeGroup: '更改分组',
        defaultGroup: "默认分组",
        operation: "操作",
        edit: "编辑",
        saveEdit: "保存编辑",
        add: "添加",
        save: "保存",
        setting: "设置",
        program: "节目",
        unbind: "解绑",
        sleep: "休眠",
        wakeup: "唤醒",
        restart: "重启",
        shutdown: "关机",
        reportLog: "上报日志",
        clearPlayData: "清除播放端数据",
        offlineWarn: "该设备已离线，设备在线后请重试！",
        confirmUnbind: "确定解绑",
        confirmReset: "确定清除",
        confirmDelete: "确定删除",
        delete: "删除",
        cancelDelete: "取消删除",
        confirmResetSuccess: "清除成功",
        confirm: "确定",
        cancel: "取消",
        operationSuccess: "操作成功",
        unbindSuccess: "解绑成功",
        pleaseSelectDevice: "请选择设备",
        pleaseSelectOnlineDevice: "请选择在线设备",
        confirmMixOperation: "所选设备中包含离线设备，该设置对离线设备不生效，确认继续操作？",
        pleaseSelectDate: "请选择日期",
        reportSuccess: "上报成功",
        deviceSetting: "设备设置",
        default: "默认",
        all: "全部",
        deviceList: "设备列表",
        addDevice: "添加设备",
        department: "部门机构",
        deviceType: "分辨率",
        osType: "终端系统",
        onlineState: "在线状态",
        online: "在线",
        offline: "离线",
        notActive: "未激活",
        search: "请输入关键字",
        batchOperation: "批量操作",
        allDevices: "全部设备",
        deviceAttribute: "设备属性",
        selectReportDate: "选择上报日期",
        inputName: "请输入名称",
        inputWidth: "请输入宽度",
        inputHeight: "请输入高度",
        inputResolutionRatio: "请输入大于0的整数！",
        inputSort: "请输入排序",
        serialNum: "序号",
        name: "名称",
        width: "宽度",
        height: "高度",
        resolutionRatio: "分辨率",
        inputResolutionRatioName: "请输入分辨率名称",
        sort: "排序",
        personal: "个人",
        system: "系统",
        type: "类型",
        systemDefaultSettingUneditable: "系统默认设置不可编辑!",
        systemDefaultSettingUnDeletable: "系统默认设置不可删除!",
        newz: "新增",
        total: "共",
        totalNum: "条",
        strategyName: "策略名称",
        associatedTerminalNum: "关联终端数量",
        createTime: "创建时间",
        pleaseSelectStrategy: "请选择策略！",
        onlySelectOneData: "只能选择一条数据！",
        downloadStrategy: "下载策略",
        inputStrategyName: "请输入策略名称",
        luminanceControl: "亮度控制",
        volumeStrategy: "音量策略",
        saveSuccess: "保存成功",
        screenAngle: "屏幕旋转(°)",
        startTime: "开始时间",
        endTime: "结束时间",
        repeat: "重复",
        monday: "周一",
        tuesday: "周二",
        wednesday: "周三",
        thursday: "周四",
        friday: "周五",
        saturday: "周六",
        sunday: "周日",
        everyday: "每天",
        downloadSpeed: "下载速度",
        inputDownloadSpeed: "请输入下载速度",
        operator: "操作",
        pleaseSelectDeleteData: "请选择要删除的数据！",
        confirmBatchDelete: "确认批量删除吗？",
        pleaseInputName: "请输入名称",
        detailSetting: "详细设置",
        weekPlan: "周计划",
        specialDateSetting: "特殊日期设置",
        weekdayInfo: "星期为必选项!",
        volumeInfo: "音量为必选项!",
        timeError: "时间选择错误!",
        editSuccess: "编辑操作成功！",
        addSuccess: "添加操作成功！",
        addSpecialPlan: "添加特殊策略计划",
        downloadSpeedInfo: "下载速度:(0代表禁止下载)",
        pleaseSelectStartTime: "请选择开始时间",
        pleaseSelectEndTime: "请选择结束时间",
        luminanceError: "请输入正确的亮度值！",
        defaultLuminance: "默认亮度",
        luminance: "亮度大小",
        defaultLuminanceInfo: "默认亮度(100表示最亮,0表示最暗)",
        volume: "音量",
        saveLuminance: "保存亮度",
        changeSuccess: "更改成功！",
        changeNetwork: "更换网络",
        netName: "网络名称",
        nameempty: "网络名称不能为空",
        currentNetwork: "当前网络",
        ipAddress: "IP地址",
        dailyMode: "每天模式",
        weeklyMode: "每周模式",
        turnOnTime: "开机时间",
        turnOffTime: "关机时间",
        startSleep: "开始休眠",
        endSleep: "结束休眠",
        batchDelInfo: "确定删除选中项吗？",
        timeCannotBeEmpty: "时间不能为空!",
        startUp: "开机",
        shutDown: "关机",
        volumeSize: "音量大小",
        defaultVolume: "默认音量(100表示最大,0表示静音)",
        chooseStartTime: "请选择开始时间",
        chooseEndTime: "请选择结束时间",
        saveVolume: "保存音量",
        screenRotationUnSaved: "屏幕旋转未保存",
        volumeSettingUnSaved: "音量设置未保存",
        luminanceSettingUnSaved: "亮度设置未保存",
        confirmClosePopup: "确认关闭此弹窗吗?",
        volumeSettingSuccess: "音量修改成功",
        luminanceSettingSuccess: "亮度修改成功",
        advancedSettingUnSaved: "高级设置未保存",
        settingTitle: "终端设置",
        volumeSetting: "音量设置",
        luminanceSetting: "亮度设置",
        downloadSetting: "下载设置",
        sleepSetting: "休眠设置",
        onOffSetting: "定时开关机",
        screenRotation: "屏幕旋转",
        namingError: "命名错误，文件名中不可有空格！",
        deleteSuccess: "删除成功",
        deleteFolder: "删除文件夹",
        pleaseInputDeviceName: "请输入设备名称",
        pleaseInputDeviceId: "请输入设备id",
        discoverDevice: "发现设备",
        deviceId: "设备ID",
        bound: "已绑定",
        bind: "绑定",
        noDevice: "暂无设备",
        refresh: "刷新",
        manualAdd: "手动添加",
        deviceGroup: "设备分类",
        pleaseSelectGroup: "请选择分组！",
        deviceName: "设备名称",
        goAdd: "前往添加",
        close: "关闭",
        bindCountInsufficient: "可绑定数量不足，请升级设备数量后添加！",
        displayNumber: "显示编号",
        groupName: "分组名称",
        pleaseSelectGroupName: "请填写分组名称！",
        moveGroup: "移动分组",
        longitude: "经度",
        latitude: "纬度",
        nationality: "国籍",
        province: "省",
        city: "市",
        county: "县",
        outNetIp: "外网ip",
        inNetIp: "内网ip",
        companyName: "企业名称",
        Info: "详情",
        android: "安卓",
        win: "win",
        osVersion: "系统版本",
        softwareVersion: "软件版本",
        diskSize: "磁盘大小",
        useSize: "已用大小",
        macAddr: "MAC地址",
        longitudeLatitudeInfo: "经纬度必须同时为空或者不为空!",
        terminalName: "终端名称",
        terminalGroup: "终端分组",
        reportJournal: "是否上报",
        systemVersion: "系统版本",
        storageSpace: "储存空间",
        resolution: "分辨率",
        runningMemory: "运行内存",
        model: "型号",
        registerStatus: "注册状态",
        password: "密码",
        passwordInfo: "请输入6到18位单词或数字!",
        group: "分组",
        address: "地址",
        remark: "备注",
        renewalPeriod: "续费周期",
        money: "费用",
        latitudeInfo: "请输入正确的纬度!",
        totalPayment: "总金额",
        longitudeInfo: "请输入正确的经度!",
        setMeal: "套餐",
        number: "数量",
        programName: "节目名称",
        playStatus: "播放状态",
        playType: "播放方式",
        play: "播放",
        pause: "暂停",
        playTime: "播放时间",
        programDeleted: "节目已删除",
        playSuccess: "节目已安排播放",
        pauseSuccess: "暂停成功",
        playCycle: "轮播",
        playInsert: "插播",
        withdrawSuccess: "撤回成功",
        withdrawInfo: "请先选择撤回的节目！",
        programBelong: "所属节目",
        checkAll: "全选",
        batchDel: "批量删除",
        delConfirm: "确定删除选中项吗？",
        check: "选中",
        noProgram: "暂无节目",
        details: "详情",
        screenshotFail: "截图失败",
        policyName: "策略名字",
        terminalNum: "关联终端数量",
        powerStrategy: "电源策略",
        pleaseSelectDepartment: "请选择部门！",
        screenshotControl: "截图控制",
        未激活: "未激活",
        已激活: "已激活",
        未绑定: "未绑定",
        已绑定: "已绑定",
    },
    programManage: {
        programList: "节目列表",
        publishProgram: "节目发布追溯",
        week1: "周一",
        week2: "周二",
        week3: "周三",
        week4: "周四",
        week5: "周五",
        week6: "周六",
        week7: "周日",
        monday: "星期一",
        tuesday: "星期二",
        wednesday: "星期三",
        thursday: "星期四",
        friday: "星期五",
        saturday: "星期六",
        sunday: "星期日",
        name: "名称",
        preview: "预览",
        playDeviceNum: "播放设备数",
        copyDeviceCode: "点击复制",
        osType: "系统类型",
        playDate: "播放日期",
        playWeek: "播放周",
        everyday: "每天",
        start: "起",
        end: "止",
        playOperateStatusStr: "发布状态",
        playDevice: "播放设备",
        downloadView: "下载查看",
        publisher: "发布者",
        publishTime: "发布时间",
        operation: "操作",
        add: "添加",
        groupName: "分组名称",
        selectDevice: "选择终端",
        searchDevice: "搜索终端",
        pleaseFillGroupName: "请填写分组名称！",
        remarkInfo: "备注",
        compile: "编辑",
        withdrawConfirm: "确认撤回该节目？",
        confirm: "确定",
        cancel: "取消",
        withdraw: "撤回",
        batchWithdraw: "批量撤回",
        batchPublish: "批量发布",
        batchDelete: "批量删除",
        batchOperation: "批量操作",
        notUse: "未使用",
        notChecked: "未审核",
        notPass: "未通过",
        delete: "删除",
        publishTextLeft: "已发布",
        offTextLeft: "已暂停",
        pleaseSelectProgramToMove: "请选择要转移的节目！",
        pause: "暂停",
        pauseConfirm: "确定暂停吗？",
        play: "播放",
        downloadUdisk: "下载U盘",
        deviceList: "设备列表",
        groupSelection: "分组选择",
        operationSuccess: "操作成功",
        deleteSuccess: "删除成功",
        selectDate: "选择日期",
        publishStatus: "发布状态",
        checkStatus: "审核状态",
        waitAuditing: "待审核",
        auditPass: "审核通过",
        auditRefuse: "审核拒绝",
        all: "全部",
        playStatus: "播放中",
        playStatust: "播放状态",
        pauseStatus: "已暂停",
        notStartStatus: "未开始",
        resolutionratio: "分辨率",
        totalNum: "条",
        programName: "节目名称",
        playStartTime: "播放开始时间",
        playEndTime: "播放结束时间",
        createTime: "创建时间",
        nationality: "国籍",
        province: "省份",
        city: "城市",
        county: "区县",
        address: "地址",
        ip: "IP地址",
        location: "位置",
        log: "日志",
        pleaseFillProgramName: "请填写节目名称！",
        selectGroup: "选择分组",
        startTime: "开始时间",
        endTime: "结束时间",
        publishCycle: "发布周期",
        publishDeviceNum: "发布设备数",
        pleaseSelectRecord: "请选择记录",
        deviceName: "终端名称",
        deviceId: "终端设备ID",
        deviceGroupIdName: "所在分组",
        notClassified: "未分类",
        osTypeStr: "终端系统",
        storageSpace: "储存空间",
        onLineStatus: "在线状态",
        onLine: "在线",
        offLine: "离线",
        sleep: "休眠",
        unknown: "未知",
        registerStatus: "注册状态",
        trialPeriod: "试用期",
        notActive: "未激活",
        active: "已激活",
        parameterError: "参数有误!",
        pleaseSelectProgram: "请选择节目!",
        pleaseSelectProgramEdit: "请选择编辑的节目!",
        confirmWithdrawSelectedProgram: "确认撤回所选节目？",
        withdrawSuccess: "撤回成功",
        allPrograms: "全部节目",
        defaultGroup: "默认分组",
        cannotShareEmptyProgram: "无法分享空节目！",
        onlyShareYourProgram: "只能分享您创建的节目!",
        pleaseSelectProgramEditPublishTime: "请选择编辑完发布时间的节目!",
        pleaseSelectDevice: "请选择设备!",
        programDetail: "节目详情",
        errorReason: "错误原因",
        availableStorageSpaceInsufficient: "可用储存空间不足",
        partialDeviceReleaseFailure: "部分设备发布失败",
        allDeviceReleaseSuccess: "所有设备发布成功",
        partialDeviceReleaseSuccess: "部分设备发布成功",
        allGroup: "所有分组",
        allProgram: "所有节目",
        unGrouped: "未分组",
        replaceProgram: "替换节目",
        replaceProgramTip: "新发布的节目将替换播放端原有下发的节目数据！",
        screen: "单双屏",
        singleScreen: "单屏",
        doubleScreen: "双屏",
        playSetting: "播放设置",
        batchPlaySetting: "批量设置播放时间",
        individualPlaySetting: "逐个设置播放时间",
        playTime: "播放时间",
        daily: "每天",
        weekdays: "周一至周五",
        monthly: "当月",
        advancedSetting: "高级设置",
        playProgram: "播放节目",
        searchProgram: "请输入关键字",
        shareAddressNotExist: "链接地址不存在，请重试",
        copySuccess: "复制成功",
        shareLink: "分享链接",
        publish: "发布",
        noResource: "暂无资源",
        single: "单屏",
        double: "双屏",
        time: "时间",
        associatedTerminalNum: "关联终端数量",
        default: "默认",
        moveGroup: "移动分组",
        pleaseSelectGroup: "请填写分组名称！",
        copy: "复制",
        FUBEN: "副本",
        nameempty: "名称不能为空",
        whitespace: "命名错误，文件名中不可有空格！",
        programWhitespace: "命名错误，节目名称中不可以有空格！",
        pleaseSelectResolution: "请选择分辨率！",
        dataError: "数据有误！",
        createProgram: "新建节目",
        directCreate: "直接创建",
        myTemplate: "我的模板",
        use: "使用",
        free: "免费",
        loadMore: "加载更多",
        confirmDelete: "确认删除",
        deleteGroup: "删除分组",
        notPublished: "未发布",
        notPassed: "未通过",
        notUsed: "未使用",
        confirmDeleteSelectedProgram: "确认删除所选节目？",
        companyName: "企业名字",
        programCannotDownload: "该节目不可下载！",
        publishMaterial: "发布素材",
        playMaterial: "播放素材",
        pleaseInputMaterialName: "请输入素材名称",
        size: "大小",
        pleaseInputDeviceName: "请输入设备名称",
        item: "条",
        allMaterial: "全部素材",
        allDevices: "全部设备",
        saveSuccess: "保存成功",
        savefaill: "保存失败",
        playMode: "播放方式",
        cyclePlay: "轮播",
        insertPlay: "插播",
        noData: "暂无数据",
        Add: "新增",
        "replace": "替换",
        "repeat": "重复",
        "start01": "开始",
        "end01": "结束",
        "startDate": "开始日期",
        "endDate": "结束日期",
        "useNow": "立即使用",
        "fillStartEndTimeFirst": "请填写完开始与结束时间再添加",
        "fillFullPlayTime": "请填写完整播放时间",
        "fillCorrectPlayTime": "请填写正确的播放时间段",
        "sDateAndEDateBothEmptyOrFilled": "开始日期与结束日期必须同时为空或者不为空"
    },
    source: {
        addResource: "资源添加",
        width: "宽度",
        height: "高度",
        size: "大小(KB)",
        name: "名称",
        pleaseInputResourceName: "请输入资源名称！",
        addToGroup: "添加到分组",
        remark: "备注",
        promptFgIllustrate: "插画",
        promptFgRealisticPhoto: "写实照片",
        promptFgSimplisticDrawing: "简笔画",
        promptFgChineseStyle: "国风",
        promptFgPixelArt: "像素风",
        noModel: "暂无模型，请联系管理员！",
        getModelFailed: "获取模型失败，请稍后重试！或者联系管理员！",
        createImagePrompt: "正在生成图片，请稍后关闭！",
        promptEmpty: "请输入提示词",
        dpiEmpty: "请选择图片比例！",
        fgEmpty: "请选择风格！",
        style: "风格",
        idEmpty: "图片id不能为空",
        exist: "该图片已存在素材中",
        addSuccess: "添加素材成功",
        saveError: "保存图片失败，请稍后重试！",
        delSuccess: "删除成功",
        generateImage: "文生图",
        generateImagePlaceholder: '请输入你想生成的图片，如：一只蝴蝶在花海中翩翩起舞',
        aiExpand: "智能扩写",
        negativePrompt: "反向提示词",
        negativePromptTooltip: "用于明确排除用户不希望出现在输出中的内容或特征",
        imageRatio: "图片比例",
        generateImageBtn: "立即生成",
        shengchengjieguo: "生成结果",
        generateImageLoadingTip: "生成中，请勿重复点击或关闭...",
        Tooltip: "快来 AI 你的创意吧",
        saveToMaterial: "保存到素材",
        publish: "立即发布",
        download: "下载",
        generateHistory: "生成历史",
        hide: "收起",
        cancel: "取消",
        useExpand: "使用扩写",
        all: "全部",
        delete: "删除",
        loadMore: "加载更多",
        aiTip: "内容由人工智能模型生成，不代表平台的观点、立场或态度，请合理合规地使用 AI 内容",
        operationSuccess: "操作成功",
        moveGroup: "移动分组",
        groupName: "分组名称",
        pleaseSelectGroup: "请选择分组名称！",
        shenhe: "审核",
        shenheStatus: "审核状态",
        shenheSuccess: "审核通过",
        shenheRefuse: "审核拒绝",
        pleaseSelectShenheStatus: "请选择审核状态！",
        shenheRemark: "审核备注",
        pleaseInputShenheRemark: "请输入审核备注！",
        pleaseInputFileName: "请输入文件名！",
        whitespace: "命名错误，文件名中不可有空格！",
        dataError: "数据有误！",
        confirmDelete: "确认删除",
        confirm: "确定",
        deleteFolder: "删除文件夹",
        add: "添加",
        edit: "编辑",
        fileName: "文件名",
        group: "分组",
        resolution: "分辨率",
        type: "类型",
        image: "图片",
        music: "音乐",
        video: "视频",
        uploadTime: "上传时间",
        uploadUser: "上传人",
        checkTime: "审核时间",
        checkUser: "审核人",
    },
    setting: {
        nameempty: "名称不能为空",
        heightempty: "高度不能为空",
        widthempty: "宽度不能为空",
        resolutionratio: "分辨率",
        name: "名称",
        opteration: "操作",
        compile: "编辑",
        delete: "删除",
        newz: "新增",
        compileratio: "编辑分辨率",
        sheizhifenbianlvmingcheng: "设置分辨率名称",
        shezhigaodu: "设置高度",
        shezhikuandu: "设置宽度",
        xinzengfenbianlv: "新增分辨率",
        bianma: "编码",
        bianjizhongduanmingcheng: "编辑终端名称",
        xinzengzhongduan: "新增终端",
        selectPrimaryColor: '选择主题颜色',
        fullScreen: '全屏',
        exitFullScreen: '退出全屏',
    },
    tabs: {
        refresh: '刷新',
        refreshAll: '刷新全部',
        close: '关闭',
        closeOthers: '关闭其他',
        closeAll: '关闭所有',
        closeLeft: '关闭左侧',
        closeRight: '关闭右侧',
    },
    errorPage: {
        needLogin: '您还未登录！',
        pageNotFound: '您访问的页面不存在！',
        redirectTo: '跳转到',
        orReturn: '或者返回',
        previousStep: '上一步',
    },
    headerUs: {
        systemNotice: "系统通知",
        allNotices: "全部通知",
        viewAllMessages: "查看全部消息",
        contactUs: "联系我们",
        operationSuccess: "操作成功！",
        leaveMessage: "我要留言",
        messageTitle: "标题",
        messageTitleTip: "请输入标题！",
        messageContentTip: "150字以内",
        submit: "提交",
        markAsRead: "标为已读",
        success: "操作成功！"
    },
    material: {
        allMaterial: "全部素材",
        defaultGroup: "默认分组",
        auditStatus: "审核状态",
        auditPassed: "审核通过",
        auditRejected: "审核拒绝",
        pendingAudit: "待审核",
        all: "全部",
        operateSuccess: "操作成功！",
        pleaseSelectMaterial: "请选择素材！",
        moveGroup: "移动分组",
        pleaseSelectGroup: "请选择分组！",
        batchPublish: "批量发布",
        batchRecall: "批量撤回",
        batchDelete: "批量删除",
        materialList: "素材列表",
        uploadMaterial: "上传素材",
        materialType: "素材类型",
        pleaseInputMaterialName: "请输入素材名称",
        selectAll: "全选",
        confirmDeleteSelectedMaterial: "确认删除选中素材吗？",
        deleteSuccess: "删除成功",
        delete: "删除",
        publish: "发布",
        recall: "撤回",
        confirmRecallSelectedMaterial: "确认撤回选中素材吗？",
        pleaseSelectMaterialGroup: "请选择素材分组！",
        recallSuccess: "撤回成功",
        publishSuccess: "发布成功",
        batchOperate: "批量操作",
        item: "条",
        confirmDelete: "确认删除吗？",
        edit: "编辑",
        confirmRecall: "确认撤回吗？",
        unaudited: "未审核",
        notPassed: "未通过",
        operate: "操作",
        resolution: "分辨率",
        none: "无",
        confirm: '确定',
        cancel: '取消',
        AICreation: "AI创作",
    },
    uploadFile: {
        operationSuccess: "操作成功",
        uploadFile: "上传管理",
        uploadSuccess: "上传成功",
        uploadCompleted: "上传完成",
        uploadFail: "上传失败",
        ConversionFailed: "转换失败！",
        loading: "努力加载中...",
        beQueuing: "排队中...",
        Uploading: "上传中...",
        ConversionIng: "转换中...",
        ConventionalResources: "常规资源",
        DocumentResources: "文档资源",
        complete: "完成",
        upload: "上传",
        fileSizeWraning01: "素材大小超过",
        fileSizeWraning02: "请修改后重新上传！",
        fileIsEmpty: "文件为空",
        uploadFileTip: "不支持的文件格式",
        unablePreview: "未成功添加到素材库，无法预览",
        confirmDelete: "确认删除吗？",
        deleteSuccess: "删除成功",
        delete: "删除",
        confirm: "确定",
        preview: "预览",
        close: "关闭",
        cancel: "取消",
        fileType: "文件类型",
        fileSize: "文件大小",
        conversionProgress: "转换进度",
        progress: "进度",
        image: "图片",
        video: "视频",
        audio: "音乐",
        limitTip01: "一次上传",
        limitTip02: "个文件",
        okTip: "正在上传素材，请稍后关闭！",
        usableSize: '可用容量',
        sizeUnableTip: "当前可用储存空间不足，请及时清理无用的素材节省空间或联系经销商扩充容量。",
        view: "查看详情",
        fileName: "文件名",
    },
    template: {
        inputPlaceholder: '请输入',
        selectPlaceholder: '请选择',
        noAuths: "暂无权限，请联系管理员",
        operationSuccess: "操作成功",
        total: "共",
        totalNum: "条",
        dan: "单",
        shaung: "双",
        pleaseSelectGroup: "请选择分组",
        preview: "预览",
        free: "免费",
        use: "使用",
        dpi: '分辨率',
        delete: "删除",
        confirmDelete: "确认删除",
        confirmDeleteSelectedTemplate: "确认删除此模板吗",
        push: "发布",
        pushConfirm: "确认发布到公共模板吗",
        pushRemovalConfirm: "确认从公共模板下架吗",
        templateOrderRecord: "模板订单记录",
        unpublished: "未发布",
        auditing: "审核中",
        publishRejected: "发布拒绝",
        publishSuccess: "发布成功",
        offShelf: "下架",
        公共模版: "公共模版",
        我的模板: "我的模版",
        共享记录: "共享记录",
        name: "名称",
        pubdate: "发布时间",
        keySeachTip: "请输入关键字",
        allGroup: "全部分组",
        add: "添加",
        edit: "编辑",
        programName: "节目名称",
        selectGroup: "选择分组",
    },
    checkManage: {
        total: "共",
        totalNum: "条",
        operationSuccess: "操作成功",
        checkUserLogs: "审核记录（操作员）",
        checkLogs: "审核记录（审核员）",
        sourceCheck: "素材审核",
        programCheck: "节目审核",
        checkAll: "全选",
        auditPass: "审核通过",
        auditRefuse: "审核拒绝",
        auditPass01: "通过",
        auditRefuse01: "拒绝",
        auditRefuse02: "拒绝审核",
        auditor: "审核人",
        agentUserName: "发布人",
        interrogationTime: "提审时间",
        checkTime: "审核时间",
        checkName: "审核名称",
        checkType: "审核类别",
        checkIp: "提审IP地址",
        checkReason: "留言",
        checkStatus: "操作内容",
        rangePicker: "审核日期",
        keyWord: "关键字",
        all: "全部",
        program: '节目',
        material: '素材',
        dan: "单",
        shaung: "双",
        pleaseSelectProgram: "请选择节目!",
        pleaseSelectMaterial: "请选择素材！",
        preview: "预览",
        dpi: '分辨率',
        auditRefuseTip: "请输入拒绝原因",
        unreviewed: "未审核",
        notPassed: "未通过",
        notUsed: "未使用",
        edit: "编辑",
        none: "无",
        name: "名称",
        size: "大小",
        type: "类型",
        uploadTime: "上传时间",
        uploadUser: "上传人",
        checkUser: "审核人",
        image: "图片",
        music: "音乐",
        video: "视频",
    },
    systemSet: {
        total: "共",
        totalNum: "条",
        inputPlaceholder: '请输入',
        selectPlaceholder: '请选择',
        userList: "组织成员",
        roleList: "角色权限",
        department: "组织架构",
        diskInfo: "储存空间",
        approveSet: "内容审批",
        logList: "日志管理",
        name: "姓名",
        account: "账号",
        userName: "用户姓名",
        phoneNumber: "手机号",
        role: "角色",
        createTime: "创建时间",
        operation: "操作",
        edit: "编辑",
        delete: "删除",
        addNew: "新增",
        add: "添加",
        resetPassword: "重置密码",
        confirmDelete: "确定删除",
        departmentOrganization: "部门机构",
        addNewUser: "新增用户",
        pleaseEnterUserName: "请输入用户姓名",
        confirmPasswordNotMatch: "确认密码与密码输入的不同!",
        operationSuccess: "操作成功！",
        userNickname: "用户名称",
        pleaseEnterUserNickname: "请输入用户名称",
        userNicknameRequired: "用户名称不能为空！",
        password: "密码",
        pleaseEnterPassword: "请输入密码",
        passwordRequired: "密码不能为空！",
        passwordTip: "您的密码安全性太低（密码中必须包含大小写字母、数字、特殊字符任意3种且长度在8",
        confirmPassword: "确认密码",
        pleaseEnterPhoneNumber: "请输入手机号",
        phoneNumberRequired: "手机号不能为空！",
        phoneNumberFormatError: "请输入正确的手机号！",
        roleRequired: "角色不能为空！",
        required: "不能为空！",
        departmentName: "部门",
        modifyPassword: "修改密码",
        newPassword: "新密码",
        pleaseEnterNewPassword: "请输入新密码",
        pwdMessage: "密码长度8~20字符，不能包含空格且必须包含大小写字母、数字、特殊字符其中3种",
        all: "全部",
        noAuths: "暂无权限，请联系管理员",
        departmentName01: "部门名称",
        image: "图片",
        music: "音乐",
        video: "视频",
        buySize: "购买数量",
        totalMoney: "付费金额",
        buycreateTime: "购买时间",
        endTime: "到期时间",
        buyTypeStr: "订单类型",
        sourceCheck: "素材审核",
        programCheck: "节目审核",
        programName: "节目名称",
        diskExpansion: "建议在使用过程中及时清理过期/不用的素材，以保证系统的可用容量。若您有更大空间的需求，您可以联系您的设备供应商获取云储存空间的容量扩充服务。此服务可能会产生费用，具体请以经销商的信息为准。",
        selectPermission: "请选择权限",
        checkPermission: "请勾选权限",
        addRole: "添加角色",
        enterRoleName: "请输入角色名称",
        roleName: "角色名称",
        roleNameRequired: "角色名称不能为空！",
        remark: "备注",
        enterRemark: "请输入备注",
        permissionSetting: "权限设置",
        deleteSuccess: "删除成功！",
        confirmToDelete: "确定删除吗？",
        orgName: "机构名称",
        orgNameRequired: "机构名称不能为空！",
        orgRemark: "机构备注",
        enterOrgRemark: "请输入机构备注",
        capacityUsage: "容量使用情况",
        usedCapacity: "已用容量",
        totalCapacity: "总容量",
        remainingCapacity: "剩余容量",
        capacityExpansion: "容量扩充",
        enable: "开启",
        disable: "关闭",
        userName01: "用户名",
        loginTime: "登陆时间",
        ipAddress: "IP地址",
        loginResult: "登录结果",
        selectDate: "选择日期",
        enterDate: "请选择日期",
        selectStartTime: "请选择开始时间",
        selectEndTime: "请选择结束时间",
        enterUserName: "请输入用户名",
        userCount: "用户数",
        roleDesc: "角色描述",
        roleAuthorization: "角色授权",
        success: "成功",
        failure: "失败",
        time: "时间",
        operationContent: "操作内容",
        playCount: "播放次数",
        playDuration: "播放时长",
        selectDevice: "选择设备",
        enterProgramName: "请输入节目名称",
        serialNumber: "序号",
        publishContentName: "发布内容名称",
        playMode: "播放方式",
        cyclePlay: "轮播",
        insertPlay: "插播",
        paddingPlay: "垫播",
        playDeviceId: "播放设备ID",
        playDeviceName: "播放设备名称",
        publishTime: "发布时间",
        downloadStatus: "下载状态",
        notDownloaded: "未下载",
        downloading: "下载中",
        downloadSucceeded: "下载成功",
        downloadFailed: "下载失败",
        enterPublishContentName: "请输入发布内容名称",
        terminalId: "终端ID",
        belongOrg: "所属机构",
        reportTime: "上报时间",
        reportIp: "上报IP",
        logInfo: "日志信息",
        details: "详情",
        confirmDeletion: "确定要删除吗？",
        logDetails: "日志详情",
        download: "下载",
        deptOrg: "部门机构",
        query: "查询",
        queryByTerminalId: "按终端ID查询",
        batchDeleteLogs: "批量删除日志",
        customTimeDeleteLogs: "自定义时间删除日志",
        selectTimeRangeFirst: "请先选择时间范围",
        deleteAllDeviceLogsIfEmpty: "若不填写设备ID，则默认删除全部设备的日志",
        enterDeviceIdToDeleteLogs: "请输入要删除日志的设备ID",
        confirmDeleteAction: "确定删除",
        selectDeleteRangeFirst: "请先选择删除范围",
        networkConnectionFailed: "网络连接失败",
        playLog: "播放日志",
        publishLog: "发布日志",
        errorLog: "错误日志",
        operationLog: "操作日志",
        fileLog: "文件日志",
        userOperateLog: "登录日志",
    },
    userManual: {
        userManual: "用户手册",
        noData: "暂无数据",
    },
    systemNotice: {
        systemNotice: "系统通知",
        noData: "暂无数据",
        total: "共",
        totalNum: "条",
        "markAllRead": "全部已读",
        "deleteAll": "全部删除",
        "all": "全部",
        "unread": "未读",
        "read": "已读",
        "type": "类型",
        "content": "内容",
        "date": "日期",
        "status": "状态",
        "confirmDelete": "确定删除吗？",
        "confirm": "确定",
        "cancel": "取消",
        "delete": "删除"
    }
};